import axios from 'axios';

/**
 * 인증 URL 생성 함수
 * @param {string} appPhase - APP PHASE ("STAGE" | "PROD")
 * @param {string} countryName - 언어 코드 (예: "ko", "en")
 * @param {{ token: string, channel: string, data?: any }} payload - 토큰, 채널, 추가 데이터
 * @returns {Promise<string>} 인증 URL 문자열
 */
export async function generateAuthUrl(appPhase, countryName, { token, channel, data }) {
  const envMap = {
    development: { prefix: 'dev-', type: 'dev' },
    STAGE: { prefix: 'stg-', type: 'stg' },
    PROD: { prefix: '', type: 'prd' },
  };

  const isDev = process.env.NODE_ENV === 'development';
  const { prefix, type: env } = isDev ? envMap.development : envMap[appPhase] || envMap.PROD;

  const baseHost = `https://${prefix}aibot-kr.samsung.com`;

  let channelUrl = '';
  try {
    const res = await axios.get(`${baseHost}/channel`, {
      params: { env, countryName },
      responseType: 'text',
    });
    channelUrl = res.data;
  } catch (error) {
    console.warn('/channel 요청 실패:', error);
    return baseHost;
  }

  let channelId = channel === 'STAR_VD' ? 'oU41I4/VnhTL8B3vd0qCkrwg578yvZuC16Dunx5TPkHW9Gzl7hB/' : 'a8a5uCpYGFQLkHy+KDrfolSKjuR5pdgryxylXEJCxhypoY5rpUpE';

  try {
    const res = await axios.post(
      `${channelUrl}/api/auth/channel`,
      {
        channel_id: channelId,
        token: token,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    const { access_token } = res.data;
    return `${channelUrl}?token=${encodeURIComponent(access_token)}`;
  } catch (error) {
    return baseHost;
  }
}
